import React, { useState } from "react";
import { Box, IconButton, TextField } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import { useIntl } from "react-intl";
import chatMessages from './messages';
import { useMfwThemeProvider } from "myfitworld-utils";
import { isMobile } from "react-device-detect";

const SendButton = ({markAsReadMessages, sendMessage}: SendButtonProps) => {
    const {formatMessage} = useIntl();
    const {mfwMobTheme} = useMfwThemeProvider();
    const [newMessage, setNewMessage] = useState("");

    return (
        <Box 
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <TextField
          onFocus={markAsReadMessages}
          style={{flex: 1}}
          value={newMessage}
          placeholder={formatMessage(chatMessages.chat_type_message)}
          onChange={(event) => setNewMessage(event.target.value)}
          onKeyPress={(event) => {
            if(newMessage.trim() !== ""){
              if(event.key === 'Enter' && !event.shiftKey && !isMobile) {
                event.preventDefault();
                sendMessage(newMessage);
                setNewMessage('');
              }
            }
          }}
          multiline = {true}
          maxRows={5}
        />
        <IconButton
          onClick={() => {sendMessage(newMessage); setNewMessage('')}}
          style={{color: newMessage === '' ? mfwMobTheme.primaryLight : mfwMobTheme.primary}}
          disabled={newMessage === ''}
        >
          <SendIcon fontSize='large'/>
        </IconButton>
      </Box>
    )
};
export default SendButton;

interface SendButtonProps {
  markAsReadMessages: () => Promise<void>,
  sendMessage: (newMessage: string) => void,
}